import React from 'react'
import { View, StyleSheet, Pressable } from 'react-native'
import { SvgUri } from 'react-native-svg'
import { Typography } from './Typography'
import { CommonActions, useNavigation } from '@react-navigation/native'

export const DCL_BLUE = '#152865'

interface HeaderProps {
  title?: string
}

const styles = StyleSheet.create({
  header: {
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    height: 60,
    width: '100%',
    paddingTop: 4,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
  },
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    paddingHorizontal: 16,
    maxWidth: 1200,
  },
  logo: {
    flexDirection: 'row',
    gap: 8,
  },
  title: {
    fontWeight: 'normal',
  }
})

const Header: React.FC<HeaderProps> = () => {
  const navigation = useNavigation()
  const navigateHome = React.useCallback(() => {
    navigation.dispatch(
      CommonActions.navigate({
        name: 'Home',
      })
    )
  }, [navigation])
  return (
    <View style={styles.header}>
      <View style={styles.container}>
        <Pressable style={styles.logo} onPress={navigateHome}>
          <SvgUri 
            uri="https://cdn1.parksmedia.wdprapps.disney.com/media/layout/syndicated/prod/assets/logos/dcl.svg"
            width="165"
            height="28"
            fill={DCL_BLUE}
          />
          <Typography variant="heading" color={DCL_BLUE} style={styles.title}>Stateroom Availability</Typography>
        </Pressable>
      </View>
    </View>
  )
}

export default Header